import { requireClientReload } from '../../../utils/clientReload';
const signature = value => {
  if (!Array.isArray(value?.channels) || value.channels.some(channel => channel !== 'customer_support') || new Set(value.channels).size !== value.channels.length) throw new Error('Invalid shared-only settings response.');
  return value.channels.includes('customer_support') ? 'on' : 'off';
};
export function createSharedOnlyMonitor({ read, update = () => {}, changed = () => requireClientReload('shared-only') }) {
  let baseline = null, generation = 0, disposed = false, observations = 0;
  const observe = (source, next) => {
    if (process.env.NODE_ENV === 'development' && observations++ < 20) console.info('[shared-only-policy]', JSON.stringify({ source, enabled: next === 'on', previous: baseline === null ? null : baseline === 'on', received_at: new Date().toISOString() }));
  };
  return {
    receive(event) {
      if (disposed || event?.success !== true || event?.data?.event_type !== 'messaging.shared_only.changed') return;
      try { const next = signature(event.data); observe('socket', next); baseline = next; generation++; update({ known: true, enabled: baseline === 'on' }); changed(); } catch { /* Invalid frames are not policy authority. */ }
    },
    async reconcile() {
      const request = ++generation;
      try {
        const next = signature(await read());
        if (disposed || request !== generation) return;
        observe('http', next);
        if (baseline !== null && next !== baseline) changed();
        baseline = next;
        update({ known: true, enabled: next === 'on' });
      } catch { /* Read failure is not OFF. Socket delivery remains active. */ }
    },
    dispose() { disposed = true; generation++; },
  };
}
